import { ContractOrProduct } from './model/contract';
import { PaymentMethodIdentifier } from './model/payment-method-identifier';
import { PaymentMethodInfo } from './model/payment-method-info';
import { EditablePaymentMethod } from './model/reusable-payment-method/editable-payment-method';
import { Paypal } from './model/reusable-payment-method/paypal';
import { ReusablePaymentMethod } from './model/reusable-payment-method/reusable-payment-method';
import { WalletPaymentMethodType } from './model/wallet-payment-method/wallet-payment-method-type';

export class ResetPaymentMethods {
  static readonly type = '[MarketplacePaymentInformation] Reset payment methods';
}

export class SetPaymentMethods {
  static readonly type = '[MarketplacePaymentInformation] Set payment methods';
  constructor(public paymentMethods: PaymentMethodInfo[]) {}
}

export class FetchPaymentMethods {
  static readonly type = '[MarketplacePaymentInformation] Fetch payment methods';
}

export class AddWalletPaymentMethod {
  static readonly type = '[MarketplacePaymentInformation] Add wallet payment method';
  constructor(public walletType: WalletPaymentMethodType) {}
}

export class CreatePaymentMethod {
  static readonly type = '[MarketplacePaymentInformation] Create new payment method';
  constructor(public paymentMethod: EditablePaymentMethod, public skipSca: boolean = false) {}
}

export class UpdatePaymentMethod {
  static readonly type = '[MarketplacePaymentInformation] Update existing payment method';
  constructor(public paymentMethod: EditablePaymentMethod, public overrideSubscription?: ContractOrProduct) {}
}

export class CreatePaymentMethodWithVerification {
  static readonly type = '[MarketplacePaymentInformation] Create new payment method with verification';
  constructor(public type: Paypal['type']) {}
}

export class CheckPaymentMethodVerification {
  static readonly type = '[MarketplacePaymentInformation] Check payment method verification';
  constructor(public timeoutInMilliseconds: number) {}
}

export class ClearPaymentMethodVerification {
  static readonly type = '[MarketplacePaymentInformation] Clear payment method verification';
}

export class DeletePaymentMethod {
  static readonly type = '[MarketplacePaymentInformation] Delete existing payment method';
  constructor(public paymentMethodIdentifier: PaymentMethodIdentifier, public deleteOnlyLocally: boolean = false) {}
}

export class PaymentMethodCreated {
  static readonly type = '[MarketplacePaymentInformation] Payment method created';
  constructor(public paymentMethod: PaymentMethodInfo) {}
}

export class PaymentMethodUpdated {
  static readonly type = '[MarketplacePaymentInformation] Payment method updated';
  constructor(public original: ReusablePaymentMethod, public update: ReusablePaymentMethod, public changed: boolean) {}
}

export class PaymentMethodDeleted {
  static readonly type = '[MarketplacePaymentInformation] Payment method deleted';
  constructor(public paymentMethod: PaymentMethodInfo) {}
}
